import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  modalAction,
  standardPriceAction,
  employeeLevelsAction,
} from './../../actions/'
import {
  modalSelector,
  standardPriceSelector,
  employeeLevelsSelector,
} from './../../selectors'
import { searchStandardPrices } from '../../function'
import CustomModal from '../../components/modal'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditStandardPrice from './edit'
import ListStandardPrice from './list'
import StandardPriceForm from '../../components/standard-price'
import CustomModalMessage from '../../components/modal-message'
import moment from '../../lib/moment.js'

class StandardPricePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      span: false,
      employee_level: '',
      employee_level_id: '',
      cost: 0,
      price: 0,
      start_date: '',
      id: '',
      search: '',
      defaultStandardPrices: [],
      standardPrices: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.handleLevel = this.handleLevel.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.findLevelByLevelID = this.findLevelByLevelID.bind(this)
  }

  componentDidMount() {
    this.props.listLevel(localStorage.getItem('access_token'))
  }
  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'standardPriceList') && get(nextProps, 'levelList') && this.state.search === '') {
      this.findLevelByLevelID(get(nextProps, 'standardPriceList'), get(nextProps, 'levelList'))
    }
    if (get(nextProps, 'standardPriceCreate.standardPriceCreate')) {
      this.props.showModal(
        'standardPrice',
        get(nextProps, 'standardPriceCreate.status'),
        get(nextProps, 'standardPriceCreate.message')
      )
      this.props.listStandardPrice(localStorage.getItem('access_token'))
      this.findLevelByLevelID(get(nextProps, 'standardPriceList'), get(nextProps, 'levelList'))
      this.props.resetCreateStandardPrice()
    }
    if (get(nextProps, 'standardPriceEdit.standardPriceEdit')) {
      this.props.showModal(
        'standardPrice',
        get(nextProps, 'standardPriceEdit.status'),
        get(nextProps, 'standardPriceEdit.message')
      )
      if (get(nextProps, 'standardPriceEdit.status') === 200) this.showSave()
      this.props.listStandardPrice(localStorage.getItem('access_token'))
      this.props.resetEditStandardPrice()
      this.handleClickEdit(false, '')
    }
    if (get(nextProps, 'standardPriceDeactivate.standardPriceDeactivate')) {
      this.props.showConfirm(
        'deleteStandardPrice',
        get(nextProps, 'standardPriceDeactivate.status'),
        get(nextProps, 'standardPriceDeactivate.message')
      )
      this.props.listStandardPrice(localStorage.getItem('access_token'))
      this.props.resetDeactivateStandardPrice()
    }
    if (get(nextProps, 'exportURL')) {
      window.open(get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportStandardPrice()
    }
  }
  findLevelByLevelID(standardPrice, levels) {
    const temp = []
    standardPrice.map((s, key) => {
      for (let i = 0; i < levels.length; i++) {
        if (levels[i]._id === s.emp_level_id) {
          temp.push({
            _id: s._id,
            level_code: levels[i].level_code,
            name: levels[i].name,
            cost: s.cost,
            price: s.price,
            start_date: s.start_date,
            updated_by: s.updated_by,
          })
        }
      }
      return s
    })
    this.setState({
      standardPrices: temp,
      defaultStandardPrices: temp,
    })
  }
  handleClickSearch() {
    this.setState({ standardPrices: get(this.state, 'defaultStandardPrices').filter(searchStandardPrices, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ standardPrices: get(this.state, 'defaultStandardPrices'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editStandardPrice, standardPrice_id) {
    this.setState({
      edit: editStandardPrice,
      id: standardPrice_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  handleLevel(e) {
    this.setState({ employee_level: e, employee_level_id: e.employee_level_id })
  }
  createLOBList() {
    const object = get(this.props, 'levelList')
    const temp = [{ label: 'Choose Level', level_code: '' }]
    if (object) {
      object.map((ob) => {
        temp.push({
          label: `${get(ob, 'level_code')} - ${get(ob, 'name')}`,
          employee_level_id: get(ob, '_id'),
        })
        return ob
      })
    }
    return temp
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your standard price information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('standardPriceForm')
  }
  cancelForm() {
    this.props.hideModal('standardPriceForm')
  }
  cancelAlert() {
    this.props.hideModal('standardPrice')
  }
  submitForm() {
    this.props.createStandardPrice(
      {
        emp_level_id: this.state.employee_level_id,
        cost: this.state.cost,
        price: this.state.price,
        start_date: new moment(this.state.start_date),
      },
      localStorage.getItem('access_token'))
    this.setState({
      cost: 0,
      price: 0,
      start_date: '',
      employee_level_id: '',
    })
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectEmployeeLevels.isAuthenticated')
    const redirect = get(this.props, 'redirectEmployeeLevels.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    const button = <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
    const buttonOK = <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
    const isFetching = get(this.props, 'getIsFetchingStandard')
    || get(this.props, 'getIsFetchingLevel')

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportStandardPrice(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          get(this.props, 'modalType') === 'standardPrice' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ get(this.props, 'modalType') === 'standardPrice' }
              type={ get(this.props, 'modalStatus') }
              message={ get(this.props, 'modalMessage') }
            />
        }
        <CustomModalMessage
          hide={ this.cancelSave }
          show={ get(this.props, 'confirmType') === 'confirmSave' }
          type={ get(this.props, 'confirmStatus') }
          message={ get(this.props, 'confirmMessage') }
          button={ buttonOK }
        />
        <CustomModalMessage
          hide={ this.cancelSave }
          show={ get(this.props, 'confirmType') === 'deleteStandardPrice' }
          type={ get(this.props, 'confirmStatus') }
          message={ get(this.props, 'confirmMessage') }
          button={ buttonOK }
        />
        <Row noGutters>
          <Col>
            <ListStandardPrice
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              standardPrices={ this.state.standardPrices }
              table={ 8 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditStandardPrice
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ get(this.props, 'confrimType') }
                confirmStatus={ get(this.props, 'confirmStatus') }
                confirmType={ get(this.props, 'confirmType') }
                confirmMessage={ get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ get(this.props, 'modalType') === 'standardPriceForm' } toggle={ this.cancelForm }>
          <StandardPriceForm
            create={ true }
            button={ button }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            handleLevel={ this.handleLevel }
            lobs={ this.createLOBList(get(this.props, 'listLOBData')) }
            employee_level={ this.state.employee_level }
            cost={ this.state.cost }
            price={ this.state.price }
            start_date={ this.state.start_date }
            confirm={ get(this.props, 'modalType') }
            cancelForm={ this.cancelForm }
            modalStatus={ get(this.props, 'modalStatus') }
            modalType={ get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

StandardPricePage.propTypes = {
  listStandardPrice: PropTypes.func.isRequired,
  resetCreateStandardPrice: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  resetEditStandardPrice: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  getIsFetchingStandard: standardPriceSelector.getIsFetching,
  getIsFetchingLevel: employeeLevelsSelector.getIsFetching,
  redirectEmployeeLevels: employeeLevelsSelector.redirectEmployeeLevels,
  standardPriceCreate: standardPriceSelector.getCreateStandardPriceData,
  standardPriceEdit: standardPriceSelector.getEditStandardPriceData,
  standardPriceGet: standardPriceSelector.getGetStandardPriceData,
  standardPriceList: standardPriceSelector.getListStandardPrice,
  standardPriceDeactivate: standardPriceSelector.getDeactivateStandardPriceData,
  exportURL: standardPriceSelector.getExportURL,
  levelList: employeeLevelsSelector.getListEmployeeLevels,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  resetAuth: authAction.resetAuth,
  createStandardPrice: standardPriceAction.createStandardPrice,
  editStandardPrice: standardPriceAction.editStandardPricel,
  getStandardPrice: standardPriceAction.getStandardPricel,
  listStandardPrice: standardPriceAction.getStandardPrice,
  resetCreateStandardPrice: standardPriceAction.resetCreateStandardPrice,
  resetEditStandardPrice: standardPriceAction.resetEditStandardPrice,
  resetDeactivateStandardPrice: standardPriceAction.resetDeactivateStandardPrice,
  listLevel: employeeLevelsAction.getEmployeeLevels,
  exportStandardPrice: standardPriceAction.exportStandardPrice,
  resetExportStandardPrice: standardPriceAction.resetExportStandardPrice,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(StandardPricePage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/standard-price/index.js